import { PropsWithChildren } from 'react'

const isTest = process.env.ACTIVE_ENV === 'test'
const isQA = (process.env.BASE_URL ?? '').indexOf('qa.aureliuslab.com') > -1

export const Head = ({
  title = 'Aurelius - The more powerful research repository and insights platform',
  description = 'Analyze, Search and Share All Your Research Insights In One Place',
  children,
}: {
  title?: string
  description?: string
} & PropsWithChildren) => {
  return (
    <>
      <html lang="en" />
      <meta charSet="UTF-8" />
      <title>{title}</title>
      {isQA && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:url" content={process.env.BASE_URL} />
      <meta property="og:title" name="title" content={title} />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        name="description"
        content={description}
      />
      <meta property="og:image" content="/images/open-graph.png" />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:width" content="663" />
      <meta property="og:type" content="website" />
      <meta
        name="viewport"
        content="width=device-width,minimum-scale=1,initial-scale=1"
      />
      {!isTest && <script defer src="https://js.stripe.com/v3/" />}
      {children}
    </>
  )
}
